import { useTheme } from "../../contexts/ThemeContext";

export default function Loading({ label = "Carregando..." }) {
  const { C } = useTheme();
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 40,
        color: C.textMuted,
        fontSize: 13,
      }}
    >
      {label}
    </div>
  );
}

export function ErrorBox({ message }) {
  const { C } = useTheme();
  return (
    <div
      style={{
        padding: "14px 18px",
        background: C.redDim,
        border: `1px solid ${C.red}40`,
        borderRadius: 10,
        color: C.red,
        fontSize: 13,
        fontWeight: 500,
      }}
    >
      {message}
    </div>
  );
}
